export default __webpack_public_path__ + "static/resume-1-3266a514d2e83f59cdde563d2f5dcf74.png";